import { Box, IconButton, styled } from '@mui/material';
import { pxToRem } from '@themes';
var AuthPageWrapper = styled(Box)(function (_ref) {
  var theme = _ref.theme;
  return {
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    backgroundColor: theme.colors.white,
    borderRadius: pxToRem(24),
    position: 'relative',
    maxWidth: pxToRem(440),
    height: pxToRem(720),
    padding: theme.spacing(8.5, 6, 6)
  };
});
var StyledIconButton = styled(IconButton)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    position: 'absolute',
    right: '5%',
    top: '3%'
  };
});
export { AuthPageWrapper, StyledIconButton };